export const drawer = {
	create: {
		title: "Añadir producto",
		notifications: {
			success: "¡Producto creado con éxito!",
			genericError: "Error al crear producto",
		},
		unsavedChanges: {
			title: "Salir de la creación",
			message:
				"¿Está seguro de que desea salir de la creación de este producto? " +
				"Perderá la información completada hasta aquí.",
			cancel: "Cancelar",
			confirm: "Salir de la creación",
		},
	},
	edit: {
		title: "Editar producto",
		notifications: {
			success: "¡Producto actualizado con éxito!",
			genericError: "Error al actualizar producto",
			barUpdateError: "Fallo al actualizar algunas asociaciones de bares.",
			barOperationsFailed: "{{ errorCount }} de {{ total }} operaciones de bar fallaron.",
		},
		unsavedChanges: {
			title: "Salir de la edición",
			message:
				"¿Está seguro de que desea salir de la edición de este producto? " +
				"Perderá la información completada hasta aquí.",
			cancel: "Cancelar",
			confirm: "Salir de la edición",
		},
	},
	linkToBars: {
		title: "Vincula tu producto a los bares",
		message:
			"¡Producto registrado con éxito! Ahora solo falta vincularlo a los bares para comenzar a vender",
		searchBars: "Buscar bares",
		selectPlaceholder: "Busca bares disponibles para vincular",
		suggestionText: "Sugerencias de bares",
		skip: "Saltar",
		linkProduct: "Finalizar",
		finishWithoutLinking: "Finalizar sin vincular",
		stock: "Inventario",
		internalIp: "IP Interna",
		notifications: {
			success: "¡Producto vinculado al/los bar(es) con éxito!",
			finishedWithoutLinking: "¡Producto registrado con éxito!",
			error: "Fallo al vincular el producto a {{ errorCount }} bar(es).",
			genericError: "Error al vincular el producto a los bar(es).",
			allFailed:
				"Fallo al vincular el producto a todos los {{ total }} bares seleccionados: {{ bars }}",
			partialSuccess:
				"Producto vinculado a {{ successCount }} de {{ total }} bares. " +
				"{{ errorCount }} fallaron: {{ failedBars }}",
		},
		success: {
			title: "¡Producto registrado con éxito!",
			message:
				"Su producto ya está activo en los bares y puede configurarlos en los bares también.",
			understand: "Entendido",
		},
	},
};
